import { autoserialize, inheritSerialization } from 'cerialize';
import { AbstractModel } from '@uzurv/core';

@inheritSerialization(AbstractModel)
export class LyftDispatchReceiptCharge extends AbstractModel {
  @autoserialize
  lyftDispatchRideId: number;

  @autoserialize
  currency: string;

  @autoserialize
  amount: number;

  @autoserialize
  paymentMethod: string;
}
